import { combineEpics } from "redux-observable";
import type { Epic } from "redux-observable";
import type { Action } from "redux";
import type { RootState } from "@/store/app/storeTypes";
import type { EpicDependencies } from "@/store/epics/epicDependencies";
import sparxsCatalogOverviewEpic from "@/features/sparxsCatalog/store/epics/sparxsCatalogOverviewEpic";
import channelDetailEpic from "@/features/channelDetail/store/epics/channelDetailEpic";
import executiveSummaryEpic from "@/features/executiveSummary/store/epics/executiveSummaryEpic";

export type { EpicDependencies };

export const coreAppEpics: Epic<Action, Action, RootState, EpicDependencies> =
  combineEpics(
    sparxsCatalogOverviewEpic,
    channelDetailEpic,
    executiveSummaryEpic,
  );
